export const ONE_COLUMN_TEMPLATE_RESEARCH_ARTICLE_IDS = ['best-used-cars-to-buy-right-now'];
